import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";
import baseURL from "../../config";

const RefundForm = ({ onRefundSuccess }) => {
  const { id } = useParams();
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleSubmit = () => {
    if (!amount || parseFloat(amount) <= 0) {
      setError("Please enter a valid refund amount.");
      return;
    }
    setError("");
    setOpenConfirm(true);
  };

  const handleConfirmRefund = async () => {
    setOpenConfirm(false);
    setLoading(true);
    setError("");
    setSuccessMsg("");

    try {
      const response = await axios.post(`${baseURL}/api/wallet/refund`, {
        userId: id,
        amount: parseFloat(amount),
        note,
      });

      setSuccessMsg(response.data?.message || "Refund processed successfully.");
      setAmount("");
      setNote("");
      onRefundSuccess();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Refund failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom color="primary">
          Refund Form
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {successMsg && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMsg}
          </Alert>
        )}

        <TextField
          label="Refund Amount"
          type="number"
          fullWidth
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          sx={{ mb: 2 }}
        />

        <TextField
          label="Note"
          fullWidth
          multiline
          rows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={loading}
          fullWidth
        >
          {loading ? <CircularProgress size={24} /> : "Process Refund"}
        </Button>

        <Dialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
        >
          <DialogTitle>Confirm Refund</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to refund <strong>${amount}</strong> from the wallet?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenConfirm(false)} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleConfirmRefund} color="error" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default RefundForm;
